import {HIDE_ERROR, SHOW_ERROR} from "../action/error-action";

let initialState = {
    errors: {
        error: null,
        action: null
    },
};
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_ERROR:
            return {
                ...state,
                errors: {
                    error: action.payload
                }
            };
        case HIDE_ERROR:
            return {
                ...state,
                errors: {
                    error: null,
                    action: null
                }
            };
        default:
            return state
    }
}